module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"previous-page":"Previous page","page":"Page","next-page":"Next page","of":" of "},"pt-BR":{"previous-page":"Página anterior","page":"Página","next-page":"Próxima página","of":" de "}}')
  delete Component.options._Ctor
}
